import React from 'react'
import PropTypes from 'prop-types'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import { Controller } from 'react-hook-form'

import { createMuiTheme } from '@material-ui/core'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'

// mark the required asterixes in red - see https://stackoverflow.com/questions/54936644/how-to-change-the-asterisk-color-in-required-field
const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131'
        }
      }
    }
  }
})

export default function ValidatedDropDown (props) {
  const {
    control,
    errors,
    name,
    label,
    helperText = '',
    rules = {},
    fullWidth = true,
    options,
    ...otherProps
  } = props

  const menuItems = options.map((option) => <MenuItem key={option.value} value={option.value}>{option.displayString}</MenuItem>)

  let required = false

  if (rules.required) {
    required = !!rules.required
  }

  return (
    <MuiThemeProvider theme={formLabelsTheme}>
      <FormControl error={!!errors[name]} fullWidth={fullWidth} {...otherProps}>
        <InputLabel required={required}>{label}</InputLabel>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select {...field}>
              {menuItems}
            </Select>
          )}
          rules={rules}
        />
        <FormHelperText>{errors[name] ? errors[name].message : helperText}</FormHelperText>
      </FormControl>
    </MuiThemeProvider>
  )
}

ValidatedDropDown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    displayString: PropTypes.string.isRequired
  })).isRequired,
  helperText: PropTypes.string,
  rules: PropTypes.object,
  fullWidth: PropTypes.bool
}
